import React, { useState, useCallback, useEffect } from 'react';

export const PromoSnackbar = React.memo(function PromoSnackbar({ message, type, isVisible, onClose, isAnimated }) {
    if (!isVisible) return null;

    const bgColor = type === 'error' ? 'bg-[#fb2c36]' : 'bg-[#00c950]';
    const borderColor = type === 'error' ? 'border-red-500' : 'border-green-500';

    return (
        <div className={`fixed top-0 left-1/2 transform -translate-x-1/2 z-50 
            ${bgColor} ${borderColor} border text-white px-4 pt-24 pb-3 shadow-xl 
            transition-all duration-500 ease-out min-w-[100%]
            ${isAnimated ? 'translate-y-0 opacity-100 scale-100' : '-translate-y-full opacity-0 '}
        `}>
            <div className="flex items-center justify-between ">
                <div className="flex items-center justify-center space-x-2 flex-1">
                    <div className={`w-1.5 h-1.5 rounded-full ${type === 'error' ? 'bg-red-300' : 'bg-green-300'}`}></div>
                    <span className="text-xs font-medium text-white">{message}</span>
                </div>
                <button
                    onClick={onClose}
                    className="text-white/70 hover:text-white transition-colors duration-200 flex-shrink-0 ml-3"
                    aria-label="Close notification"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div className="absolute bottom-0 left-0 h-0.5 bg-white/20 rounded-b-lg overflow-hidden">
                <div className={`h-full ${type === 'error' ? 'bg-red-300' : 'bg-green-300'} transition-all duration-4000 ease-linear`}></div>
            </div>
        </div>
    );
});

export function usePromoSnackbar() {
    const [snackbar, setSnackbar] = useState({ isVisible: false, message: '', type: 'error' });
    const [snackbarAnimation, setSnackbarAnimation] = useState(false);

    const closeSnackbar = useCallback(() => {
        setSnackbarAnimation(false);
        setTimeout(() => setSnackbar(prev => ({ ...prev, isVisible: false })), 500);
    }, []);

    const showSnackbar = useCallback((message, type = 'error') => {
        setSnackbar({ isVisible: true, message, type });
        setTimeout(() => setSnackbarAnimation(true), 100);
    }, []);

    useEffect(() => {
        if (snackbar.isVisible) {
            const timer = setTimeout(closeSnackbar, 4000);
            return () => clearTimeout(timer);
        }
    }, [snackbar.isVisible, closeSnackbar]);

    return { snackbar, snackbarAnimation, showSnackbar, closeSnackbar };
}
